(() => {

  // Colour and Material are required to be single-select and are enforced here,
  // in developer-controlled code, so they cannot be removed from the storefront.
  var BASELINE_SINGLE_SELECT_FILTER_PARAMS = [
    'filter.v.m.custom.farbvariante_neu_test',
    'filter.v.m.custom.material_neu',
  ];

  // Only accept real Shopify facet parameter names, and reject anything that
  // could break out of a CSS selector or a querySelector string.
  var isValidFilterParam = (name) =>
    name.indexOf('filter.') === 0 && !/["'\\<>{}();\s]/.test(name);

  // Merchant additions come from assets/s25-config.js. That list is additive
  // only: invalid entries are ignored and the baseline above always applies.
  var buildSingleSelectFilterParams = () => {
    var params = BASELINE_SINGLE_SELECT_FILTER_PARAMS.slice();

    var configured =
      window.S25_CONFIG && Array.isArray(window.S25_CONFIG.singleSelectFilterParams)
        ? window.S25_CONFIG.singleSelectFilterParams
        : [];

    configured.forEach((value) => {
      if (typeof value !== 'string') return;

      var name = value.trim();
      if (!name) return;
      if (!isValidFilterParam(name)) return;
      if (params.indexOf(name) !== -1) return;

      params.push(name);
    });

    return params;
  };

  // Single source of truth: this list drives both the exclusive-selection
  // behaviour and the radio-style appearance below.
  var SINGLE_SELECT_FILTER_PARAMS = buildSingleSelectFilterParams();

  // Give single-select filters the appearance of the theme's own radio control
  // (see .radio in theme.css), while keeping the underlying input a checkbox so
  // the active value can still be deselected.
  //
  // This is done with a generated stylesheet instead of adding classes to the
  // inputs, because Shopify replaces the whole facets markup during AJAX
  // filtering. A stylesheet keeps matching automatically, so nothing has to be
  // re-applied after a facet rerender.
  var applySingleSelectAppearance = () => {
    if (!SINGLE_SELECT_FILTER_PARAMS.length || !document.head) return;

    var selectors = (suffix) =>
      SINGLE_SELECT_FILTER_PARAMS
        .map((name) => '.checkbox[name="' + name + '"]' + suffix)
        .join(',');

    var style = document.createElement('style');
    style.id = 's25-single-select-appearance';
    style.textContent =
      selectors('') +
      '{' +
        '--radio-size:10px;' +
        'width:var(--radio-size);' +
        'height:var(--radio-size);' +
        'vertical-align:calc(.5cap - .5 * var(--radio-size));' +
        'background:none;' +
        'border:1px solid rgb(var(--text-color) / .5);' +
        'border-radius:100%;' +
      '}' +
      selectors(':checked') +
      '{' +
        'background-color:rgb(var(--accent));' +
        'background-image:none;' +
        'background-blend-mode:normal;' +
        'border-color:rgb(var(--text-color));' +
      '}';

    document.head.appendChild(style);
  };

  applySingleSelectAppearance();

  document.addEventListener('DOMContentLoaded', () => {

    document.addEventListener(
      'change',
      (event) => {
        var input = event.target;

        if (!input || !input.name || !input.checked || SINGLE_SELECT_FILTER_PARAMS.indexOf(input.name) === -1) {
          return;
        }

        var form = input.form;
        if (!form) return;

        form.querySelectorAll('input[name="' + input.name + '"]').forEach((otherInput) => {
          if (otherInput !== input && otherInput.checked) {
            otherInput.checked = false;
          }
        });
      },
      true
    );
  });
})();
